import { Drawer, Modal } from 'antd';
import { ComponentType } from 'react';
import { styled } from 'styled-components';

export const StyledModal = styled(Modal as ComponentType<any>)`
  .ant-modal-content {
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    box-shadow: 0px 4px 8px 0px rgba(65, 80, 138, 0.2);
    padding: 24px;
    border-radius: 14px;
  }

  .ant-modal-header {
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    margin-bottom: 25px;
  }

  .ant-modal-body {
    color: ${props => props.theme.colors.secondary.main.text};
    overflow: auto;
    max-height: calc(100vh - 150px);
    padding: 0 4px;
  }

  .ant-modal-footer {
    margin-top: 0;
    border-top: none;
  }
`;

export const StyledDrawer = styled(Drawer as ComponentType<any>)`
  .ant-drawer-content {
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    border-radius: 14px 14px 0 0;
  }

  .ant-drawer-header {
    background-color: ${props => props.theme.colors.neutral.light.contentBg};
    border-bottom: none;
  }

  .ant-drawer-body {
    color: ${props => props.theme.colors.secondary.main.text};
  }

  .ant-drawer-footer {
    border-top: none;
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledCloseButton = styled.button`
  background: transparent;
  border: 1.5px solid ${props => props.theme.colors.secondary.light.border};
  cursor: pointer;
  border-radius: 8px;
  padding: 12px;

  svg {
    color: ${props => props.theme.colors.secondary.main.icon};
    transition: opacity 0.3s;
    &:hover {
      opacity: 0.7;
      color: ${props => props.theme.colors.secondary.main.text};
    }
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  gap: 8px;
  color: ${props => props.theme.colors.secondary.main.text};
  font-size: 16px;
  font-weight: 700;
  align-items: center;

  svg {
    color: ${props => props.theme.colors.secondary.main.icon};
  }

  p {
    margin: 0;
  }
`;

export const StyledFooter = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;
